import DirectMessageNavigation from 'components/DirectMessageNavigation/DirectMessageNavigation.vue'
import DirectMessageThread from 'components/DirectMessageThread/DirectMessageThread.vue'

export default {
    name: "DirectMessagesContent",
    components: {
        DirectMessageNavigation,
        DirectMessageThread
    },
    props: {
        chatId: {
            type: String,
            required: false
        },
        userData: {
            type: Object,
            required: true
        },
        guid: {
            type: String,
            required: true
        }
    },
    setup(){
    }
}